import { Component } from 'vue-property-decorator';
import { FormControlClass } from '@/core';

@Component
export default class PasswordInput extends FormControlClass<string> {
  public isPasswordShow = false;
}
